/**
 * Loads a store map embed only once the map is on screen, such as when its dialog opens. Browsers load hidden
 * iframes straight away even with loading="lazy", which would fetch Google Maps on every product page view.
 */
class StoreMap extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    const frame = this.querySelector('iframe[data-src]');
    if (!(frame instanceof HTMLIFrameElement)) return;

    this.#observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      frame.src = frame.dataset.src ?? '';
      frame.removeAttribute('data-src');
      this.#observer?.disconnect();
    });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('store-map')) customElements.define('store-map', StoreMap);
